import { observer } from "mobx-react";
import moment from "moment";
import React from "react";
import styled from "styled-components";

import DatetimePicker from "@client/components/ui/DatetimePicker";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const DashboardTitleText = styled.div`
  margin-right: 8px;
`;

type Props = {
  title: string;
  date: Date | null;
  onChange: (date: Date | null) => void;
};

@observer
class DashboardTitle extends React.Component<Props> {
  render() {
    return (
      <Wrapper>
        <DashboardTitleText>{this.props.title}</DashboardTitleText>
        <DatetimePicker
          value={this.props.date}
          onChange={this.props.onChange}
          timezone="utc"
          monthMode
          useBold
          dispatchChangeContinously
          emptyDateLabel="Last 30 days"
          dateFormat="MMM YYYY"
          width={130}
          showClearButton
          onClear={() => {
            this.props.onChange(null);
          }}
          isValidDate={date => moment(date).isBefore(moment().endOf("day"))}
        />
      </Wrapper>
    );
  }
}

export default DashboardTitle;
